export default "__VITE_ASSET__fc628cf7__"